if (!customElements.get('ticker-list')) {
  class TickerList extends HTMLElement {
    constructor() {
      super();
      this.isRunning = false;
      this.speed = 50;
      this.wrapperClass = this.dataset.wrapperClass ?? 'ticker__items';

      this.clone();
      this.animate();
      this.onMouseEnter = this.pause.bind(this);
      this.onMouseLeave = this.play.bind(this);
    }

    connectedCallback() {
      this.addEventListener('mouseenter', this.onMouseEnter);
      this.addEventListener('mouseleave', this.onMouseLeave);
      this.observe();
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onMouseEnter);
      this.removeEventListener('mouseleave', this.onMouseLeave);
      this.observer.disconnect();
    }

    observe() {
      this.observer = new IntersectionObserver(
        entries => {
          if (entries[0].isIntersecting) {
            this.play();
          } else {
            this.pause();
          }
        },
        {
          rootMargin: '200px 0px',
        }
      );

      this.observer.observe(this);
    }

    clone() {
      const tickerItems = this.innerHTML;
      const wrappedItems = `<div class="${this.wrapperClass}" data-ticker-items>${tickerItems}</div>`;
      this.innerHTML = wrappedItems + wrappedItems + wrappedItems;
    }

    animate() {
      this.contentWidth = this.querySelector('[data-ticker-items]').offsetWidth;
      this.duration = this.contentWidth / this.speed;

      this.tween = gsap.to(this.querySelectorAll('[data-ticker-items]'), {
        duration: this.duration,
        xPercent: -100,
        ease: 'none',
        repeat: -1,
      });

      this.isRunning = true;
    }

    play() {
      this.tween.play();
    }

    pause() {
      this.tween.pause();
    }
  }

  customElements.define('ticker-list', TickerList);
}